export default __webpack_public_path__ + "static/media/selecta_medium@2x.70478e4b.jpg";